import { lazy, Suspense } from 'react';

import { checkout } from 'core';

import HeaderWidget from './widgets/HeaderCheckout';
const PaymentWidget = lazy(
  () => import(/* webpackChunkName: "widgets-payment" */ './widgets/Payment'),
);
const SummaryWidget = lazy(
  () => import(/* webpackChunkName: "widgets-payment" */ './widgets/Summary'),
);
const CheckoutContainer = () => {
  const { step } = checkout.hooks.useCheckout();
  return (
    <Suspense>
      <HeaderWidget />
      {step === 'payment' ? <PaymentWidget /> : <SummaryWidget />}
    </Suspense>
  );
};

export default CheckoutContainer;
